export default [
  {
    name: 'dashboard',
    label: 'Dashboard',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'partners',
    label: 'Shareholders',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'portfolio',
    label: 'Portfolio',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'drafts',
    label: 'Drafts',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'plans',
    label: 'Plans',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'transactions',
    label: 'Transactions',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'equityMarket',
    label: 'EquityMarket',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: true,
  },
  {
    name: 'communications',
    label: 'Communications',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'boards',
    label: 'Boards',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'signatures',
    label: 'Signatures',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'documents',
    label: 'Documents',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'societyConfiguration',
    label: 'SocietyConfiguration',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: false,
  },
  {
    name: 'analytics',
    label: 'Analytics',
    enabled: true,
    checked: false,
    readOnly: false,
    isNew: true,
  },
];
